<!-- src/components/QuiSommesNous/QuiSommesNousArticles.vue
<template>
  <div class="service-wrap pt-20 pb-20">
    <div class="container">

      <div class="row">
        <div class="col-xl-4 col-lg-6 col-md-6" v-for="(article, index) in truncatedArticles" :key="index">
          <div class="blog-card style1">
            <div
              class="blog-img"
              :style="{
                height: '277px',
                backgroundImage: `url(${getUrlApiForFiles(article.urlImage)})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }"
            ></div>
            <div class="blog-info" style="min-height: 250px;">
              <ul class="blog-metainfo list-style">
                <li><i class="flaticon-user"></i> EITP</li>
                <li><i class="flaticon-calendar"></i>{{ format_Date(article.datePublication) }}</li>
              </ul>
              <h3>
                <router-link :to="{ name: 'ViewArticlePage', params: { id: article.id } }">
                  {{ article.titre }}
                </router-link>
              </h3>
              <router-link
                :to="{ name: 'ViewArticlePage', params: { id: article.id } }"
                class="link style1"
              >
                Lire plus <i class="flaticon-right-arrow"></i>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-4">
        <PaginationComponent
          :page="page"
          :totalPages="totalPages"
          :totalElements="totalElements"
          :limit="limit"
          @paginate="handlePaginate"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ApiService from "@/services/ApiService";
import { getUrlApiForFiles, error, format_Date } from "@/utils/utils";
import { defineComponent, ref, onMounted, computed } from "vue";
import { Article } from "@/models/Article";
import PaginationComponent from '@/components/Utilities/Pagination.vue';

export default defineComponent({
  name: 'QuiSommesNousArticles',
  components: { PaginationComponent },
  setup() {
    const articles = ref<Array<Article>>([]);

    // PAGINATION
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(9);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      page.value = page_;
      getTreeArticle(page_, limit_);
    };

    // Récupérer les articles de la catégorie "Qui sommes-nous ?"
    function getTreeArticle(page = 1, limi = 9, searchTerm = '') {
      return ApiService.get(`/actualite/articles/18?page=${page}&limit=${limi}&mot=${searchTerm}&`)
      
      .then(({ data }) => {
        console.log ("gggggggg",  data.data.data)
        articles.value = data.data.data;
        totalPages.value = data.data.totalPages;
        limit.value = data.data.limit;
        totalElements.value = data.data.totalElements;
      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    } 

    // Tronquer le titre si trop long
    const truncatedArticles = computed(() => {
      const maxLength = 80;
      return articles.value.map(article => ({
        ...article,
        titre: article.titre.length > maxLength
          ? article.titre.substring(0, maxLength) + '...'
          : article.titre
      }));
    });

    onMounted(() => {
      getTreeArticle();
    });

    return {
      articles,
      getUrlApiForFiles,
      format_Date,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      truncatedArticles
    };
  },
});
</script>

<style scoped>
.blog-card .blog-info h3 {
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 15px;
}
</style> -->

<template>
  <div class="info-wrap py-5">
    <div class="container">
      <!-- Section Statuts et règlements -->
      <!-- Section Statuts et règlements -->
<div class="row align-items-start mb-5 section-row">

  <!-- Image -->
  <div class="col-md-6">
    <img src="../../assets/images/photo 14.jpg" alt="Statuts et règlements" class="section-img">
  </div>

  <!-- Titre + Objectif -->
  <div class="col-md-6">
    <h3 class="section-title">Statuts et règlements</h3>

    <!-- Objectif -->
    <h5 class="sub-title">1) Objectif</h5>
    <p class="section-text">
      À l’Ecole d’Initiation Théologique et Pastorale, le terme clé « Initiation » intègre à la fois la dynamique culturelle et didactique. Il implique, selon une pédagogie appropriée et graduelle, une disponibilité à la nouveauté de l’Évangile et un crédit de bienveillance. C’est le Christ, le Maître d’initiation, qui chemine avec chacun comme avec les disciples d’Emmaüs (Lc 24, 13-35) dont le récit constitue un paradigme essentiel de ce parcours de foi. De cette péricope, ont été dégagés cinq axes majeurs de spiritualité :
    </p>

    <ul class="custom-list">
      <li>Des hommes et femmes en marche ensemble</li>
      <li>Portant un regard lucide sur la société, les cultures et l’Église</li>
      <li>Se nourrissant de la Parole de Dieu</li>
      <li>Reconnaissant le Christ à la fraction du pain</li>
      <li>Disponibles pour la mission</li>
    </ul>

  </div>
</div>

<!-- NOUVELLE SECTION PLEINE LARGEUR -->
<div class="row mt-4">
  <div class="col-12">

    <!-- Présentation de l'École -->
    <h5 class="sub-title">2) Présentation de l’École</h5>
    <ul class="custom-list">
      <li>a-	L’EITP est un parcours à la suite du Christ, un cadre d’approfondissement de la foi, une école de témoignage et d’engagement, un creuset de créativité.</li>
      <li>b-	Tenue et retenue sont requises de chaque apprenant(e) à l’EITP.
        Durant les devoirs ou examens, toute situation de compromission est absolument évitée. Le recours au cours, quand il n’est pas explicitement indiqué, et l’utilisation du portable sont prohibés. L’usage du téléphone pendant les devoirs et examens est une grave situation de compromission. Toute personne surprise en situation objective de compromission se soumettra à des séances d’accompagnement proposées par l’école. Son statut maximal pour cette année est celui d’Auditeur. Et son cours en sera informé. 
      </li>
      <li>c-	Il n’est pas permis de manger dans les salles de classe ou pendant les cours et d’utiliser au cours le téléphone portable.
</li>
    </ul>

    <!-- Normes -->
    <h5 class="sub-title">Quelques normes</h5>
    <h5>1)	Dispositions générales</h5>
    <ul class="custom-list">
      <li>Après les entretiens, l’inscription est validée et finalisée par le dépôt des dossiers complets, le paiement des frais académiques, la lecture et la moyenne à l’évaluation du guide de l’apprenant.</li>
      <li>Au début de chaque cours, se prend l’une des prières retenues à cet effet (ou celle de Saint Augustin ou celle de Saint Hilaire de Poitiers) ; à la fin des cours, il y a la prière des Vêpres pour les groupes de 16h et de Complies pour ceux de 19h. Pour le samedi, c’est la prière du Milieu du jour qui conclut la dernière séance. Le cours commence avec la lecture de la vie des saints. Les responsables de groupe y veilleront.</li>

Les mardis (à 18h 30) et les samedis (à 12h 45), il y a messe.
      <li>A la dernière séance d’un module, les apprenants évaluent, en toute liberté et vérité, la prestation du professeur, sur des fiches qui leur sont partagées à la dernière séance de ce module. Ils participent ainsi à la qualité de la formation.</li>
      <li>Tout(e) inscrit(e) achèvera son initiation au plus en trois ans consécutifs. Les cas exceptionnels n’excéderont pas quatre ans.</li>
      <li>A la fin de la première année, la possibilité régulière de s’inscrire en 2ème année est liée à la validation au moins du statut d’auditeur.</li>
      <li>Il est strictement interdit de venir aux cours ou aux devoirs avec des enfants.</li>
      <li>Pour les suggestions, les demandes de rendez-vous, passer au secrétariat ; par ailleurs, sont recommandées les demandes de rendez-vous par voie téléphonique (appels ou messages) ou électronique. Contacts : eitpcotonou@gmail.com.
Selon la nature de la doléance et du sujet, s’adresser au Père formateur responsable du pôle.</li>
      <li>Les doléances peuvent être déposées au secrétariat ou dans la boîte à suggestions. </li>
      <li>Pour les questions académiques (rattrapages, devoirs, cours non faits…), envoyer les préoccupations à l’adresse électronique : sarattrapageeitp@gmail.com. Pour les autres questions, envoyer les préoccupations à l’adresse électronique : eitpcotonou@gmail.com.
Chaque apprenant dispose d’une page sur le site internet de l’Ecole avec un mot de passe personnel, où sont stockées ses données personnelles. Chacun est donc invité à s’inscrire sur le site et à le consulter souvent, à s’inscrire sur les réseaux sociaux de l’école (Facebook ; Youtube ; Tiktok ; Instagram) et à partager les informations ou formations de l’école.</li>
    </ul>

    <!-- Paiement -->
    <h5 class="sub-title">2)	Des frais académiques</h5>
    <p class="section-text">
     Les frais académiques, une fois payés, sont non remboursables. <br>
L’acquittement total des frais de la 1ère année est indispensable pour l’inscription en 2ème année.
    </p>

    <ul class="custom-list">
      <li>UBA – N° 501100007916</li>
      <li>IBAN : BJ0670150150110000791654</li>
      <li>Code SWIFT/BIC : COBBBJBJ.</li>
      <li>Titulaire :ECOLE D’INITIATION THEOLOGIQUE ET PASTORALE.</li>
    </ul>
    <p class="section-text">❖	Le respect des échéances favorise une sereine organisation de la formation. Tout apprenant peut payer en une seule tranche ses frais académiques.
      <br>❖	Qui a des difficultés de paiement, avant les diverses échéances établies, prend un engagement ou moratoire à respecter. Le faire après les échéances établies n’est pas efficient.
      <br>❖	Tout apprenant non à jour avec les frais académiques (non-paiement ; absence d’engagement dûment signé ou engagement non honoré) n’a pas son nom sur la liste de présence et n'est pas autorisé à suivre les cours. S'il suivait les cours, sa présence est nulle et il pourrait se voir éconduit de la classe. 
      <br>❖	Les listes de présence sont remises à jour en début de chaque semaine.
      <br>❖	Qui ne serait pas en règle par rapport aux frais académiques et parce que son nom ne figurerait pas sur la liste de son groupe, suit le cours dans un autre groupe et se fait enregistrer comme étant en rattrapage, verra son année invalidée.
      <br>❖	Par ailleurs, pour le pèlerinage, les formations et les parcours spirituels, des frais de participation sont sollicités et sont à payer avant les diverses échéances indiquées.
      </p>
  
      <h5 class="sub-title">3) La présence en bibliothèque</h5>
      <p class="section-text">Chaque apprenant est invité à se rendre en bibliothèque. La bibliothèque est accessible aux heures d’ouverture du secrétariat de l’EITP à Saint Michel. </p>
      <h5>4) La Revue de l’Ecole</h5>
      <p class="section-text">Tout apprenant se procure chaque numéro de la Revue (à un prix réduit) et aide à faire écouler au moins un numéro dont il rend compte dans le délai d’un mois après la distribution.</p>
      <h5>5) Accompagnement institutionnel</h5>
      <p class="section-text">L’accompagnement institutionnel offre aux apprenants la possibilité d’échanger avec un des prêtres préposés à ce service, à des jours et heures définis, dans les locaux de l’École sur le parcours d’initiation proposé. Ce creuset est un moment de partage sur les préoccupations relatives à leur formation et qui ne sont pas souvent prises en compte lors des autres creusets (cours et autres). Il est offert sur demande expresse de l’étudiant qui voudrait faire part de certaines préoccupations personnelles et particulières. </p>
      <h5>6) Le tutorat</h5>
      <p class="section-text">C’est un service d’assistance, à certaines heures de cours, pour faciliter aux apprenants(es), regroupés en petits groupes, une meilleure connaissance mutuelle, une réelle connaissance de l’école et de sa vision. Il est assuré, sous la responsabilité du Directeur, par des anciens de l’Ecole qui en ont été préparés par un programme. Il ne remplace pas l’accompagnement institutionnel mais peut y préparer. Chaque apprenant est tenu d’y participer.</p>
    </div>
</div>

      <!-- Bouton Télécharger décret -->
      <div class="text-center mt-4">
  <a 
    href="/Statuts.pdf"
    download="Statuts.pdf"
    class="btn-download"
  >
    Télécharger fichier
  </a>
</div>


    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: "InfoSections",
};
</script>

<style scoped>
.info-wrap {
  background-color: #f8f9fa;
}

.section-row {
  padding: 20px 0;
}

.section-img {
  width: 100%;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.section-img:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0,0,0,0.2);
}

.section-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #0b1b3f;
  margin-bottom: 15px;
}

.section-text {
  font-size: 1rem;
  color: #6c757d;
  line-height: 1.7;
  text-align: justify;
}

.btn-download {
  background-color: #ffc107;
  color: #0b1b3f;
  font-weight: 700;
  padding: 12px 25px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-download:hover {
  background-color: #e0a800;
  transform: translateY(-2px);
}


</style>
